import React from 'react';
import { Dropdown } from 'carbon-components-react';
import { useAppContext } from '../../../hooks/AppContext';
import { prop } from 'ramda';
import { segmentTracking } from '../../../lib/tracker';
import { QuestionData } from 'src/apps/envizi-price-estimator/types';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/envizi-price-estimator/locales/messages';

export type stepProps = {
  isOpen: boolean;
  question: QuestionData;
};

const Step1 = ({ isOpen, question }: stepProps) => {
  const { appState, appAction } = useAppContext();
  const intl = useIntl();

  const submitted = prop('submitted')(appState);
  const submittedAnsId = submitted && submitted[question.id];
  const submittedAnsValue = submittedAnsId && Object.values(submittedAnsId)[0];
  type option = {
    id: string;
    label: string;
    point: number;
    cookieValue: string;
  };
  const handleDropdown = (value: option) => {
    appAction({
      type: 'answerSingle',
      answerId: value.id,
      answerValue: `${value.label}-${value.point} Cookie-${value.cookieValue}`,
    });
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Industry Dropdwon',
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const answers = [
    {
      id: 'Q1A1',
      label: intl.formatMessage(messages.q1_option1),
      point: 2.6,
      cookieValue: 'Government',
    },
    {
      id: 'Q1A2',
      label: intl.formatMessage(messages.q1_option2),
      point: 3.2,
      cookieValue: 'Hospitality',
    },
    {
      id: 'Q1A3',
      label: intl.formatMessage(messages.q1_option3),
      point: 3.2,
      cookieValue: 'Technology',
    },
    {
      id: 'Q1A4',
      label: intl.formatMessage(messages.q1_option4),
      point: 3.4,
      cookieValue: 'Finance',
    },
    {
      id: 'Q1A5',
      label: intl.formatMessage(messages.q1_option5),
      point: 3.5,
      cookieValue: 'Education',
    },
    {
      id: 'Q1A6',
      label: intl.formatMessage(messages.q1_option6),
      point: 3.6,
      cookieValue: 'Retail',
    },
    {
      id: 'Q1A7',
      label: intl.formatMessage(messages.q1_option7),
      point: 4.2,
      cookieValue: 'Industrial',
    },
    {
      id: 'Q1A8',
      label: intl.formatMessage(messages.q1_option8),
      point: 5.5,
      cookieValue: 'Manufacturing',
    },
    {
      id: 'Q1A9',
      label: intl.formatMessage(messages.q1_option9),
      point: 7.0,
      cookieValue: 'Real Estate',
    },
    {
      id: 'Q1A10',
      label: intl.formatMessage(messages.q1_option10),
      point: 8.0,
      cookieValue: 'Healthcare',
    },
    {
      id: 'Q1A11',
      label: intl.formatMessage(messages.q1_option11),
      point: 4.7,
      cookieValue: 'Other',
    },
  ];

  return isOpen ? (
    <div>
      <h3 className="page_sub_heading padding_8">
        <FormattedMessage {...messages.q1_que_desc} />
      </h3>
      <Dropdown
        ariaLabel="Dropdown"
        id="envizi-industry-dropdown"
        label={intl.formatMessage(messages.q1_default_label)}
        titleText={''}
        items={answers}
        selectedItem={submittedAnsValue ? submittedAnsValue.split('-')[0] : ''}
        onChange={(e) => handleDropdown(e.selectedItem)}
        light={true}
      />
    </div>
  ) : null;
};

export default Step1;
